import { useEffect, useState } from "react";
import { Hero } from "@/components/home/Hero";
import { CategoryGrid } from "@/components/home/CategoryGrid";
import { Services } from "@/components/home/Services";
import { HowItWorks, Trust } from "@/components/home/HowTrust";
import { FaqSection, CtaBand } from "@/components/home/FaqCta";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home() {
  usePageMeta(null);
  const [guestLimit, setGuestLimit] = useState(5);
  useEffect(() => {
    api.get("/usage/me").then((r) => r.data.guest && setGuestLimit(r.data.limit)).catch(() => {});
  }, []);
  return (
    <div data-testid="home-page">
      <Hero guestLimit={guestLimit} />
      <CategoryGrid />
      <Services />
      <HowItWorks />
      <Trust />
      <FaqSection />
      <CtaBand />
    </div>
  );
}
